import { io, Socket } from 'socket.io-client';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3005';

// The socket stays disconnected until the dashboard mounts listeners.
export const socket: Socket = io(API_URL, { autoConnect: false });
